/* arissai-resilience.js v26 — definitive scroll/click freeze killer */
(function(){
  "use strict";

  // Catch any error globally so it cannot freeze the UI
  window.addEventListener("error", function(e){ /* swallow */ }, true);
  window.addEventListener("unhandledrejection", function(e){ /* swallow */ });

  // FORCE passive listeners for every touch/scroll handler
  var origAdd = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function(type, fn, opts){
    if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") {
      if (typeof opts === "boolean") opts = { capture: opts, passive: true };
      else if (opts && typeof opts === "object") opts = Object.assign({}, opts, { passive: true });
      else opts = { passive: true };
    }
    return origAdd.call(this, type, fn, opts);
  };

  // De-rate scroll listeners — fire at most every 16ms via rAF coalescing
  var pending = false;
  function coalesce(handler){
    return function(e){
      if (pending) return;
      pending = true;
      requestAnimationFrame(function(){ try{ handler(e); } catch(err){} finally { pending = false; } });
    };
  }

  // iOS scroll watchdog — un-stick if main thread blocks > 600ms
  var lastTick = performance.now();
  window.addEventListener("scroll", function(){ lastTick = performance.now(); }, { passive: true });
  setInterval(function(){
    if (performance.now() - lastTick > 1200) {
      // Force a reflow flush; sometimes un-sticks safari
      try { void document.body.offsetHeight; } catch(e) {}
    }
  }, 2000);

  // Click safety net — ATC, sticky bar, links
  document.addEventListener("click", function(e){
    try {
      var a = e.target && e.target.closest && e.target.closest('a[href]:not([href="#"])');
      if (a && !a.hasAttribute("data-cart-trigger") && !e.defaultPrevented && a.target !== "_blank") {
        // Allow native nav; nothing to do, but prevents handlers from blocking
      }
    } catch(err) {}
  }, false);

  // Auto-recover stalled cart fetches
  var lastCart = 0;
  document.addEventListener("click", function(e){
    var c = e.target && e.target.closest && e.target.closest('[href*="/cart"], [data-cart-trigger]');
    if (!c) return;
    var now = Date.now();
    if (now - lastCart < 1500) return;
    lastCart = now;
    if (window.fetch) fetch("/cart.js", { credentials: "same-origin" }).catch(function(){});
  }, true);

  // Remove `will-change` after first paint (was forcing GPU layers permanently)
  document.addEventListener("DOMContentLoaded", function(){
    setTimeout(function(){
      document.querySelectorAll('[style*="will-change"]').forEach(function(el){
        el.style.willChange = "auto";
      });
    }, 1500);
  });

})();
